import React from 'react';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import StreamPlayer from '../components/StreamPlayer';
import StreamChat from '../components/StreamChat';

const Stream = () => (
  <Layout>
    <SEO
      title="Stream"
      image="https://assets.horny.moe/0000-brand-assets/streamimage.gif"
      description="Tune in live! See these pixels in all of their original, uncensored glory! Self hosted servers means no pesky content policy!"
      meta={[
        {
          name: 'twitter:site',
          content: '@hornydotmoe',
        },
        {
          name: 'theme-color',
          content: '#ff79c6',
        },
        {
          name: 'viewport',
          content: 'width=device-width, initial-scale=1',
        },
      ]}
    />
    <div className="container">
      <div className="row col-eq-height">
        <StreamPlayer />
        <StreamChat />
      </div>
    </div>
  </Layout>
);

export default Stream;
